import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Footer from './Pages/Footer';
import Header from './Pages/Header';
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import SNKB_History from './Pages/SNKB_History';
import Our_Category from './Pages/Our_Category';
import Product_Details from './Pages/Product_Details';
import PrivacyPolicy from './Pages/Privacy_Policy';
import ReturnPolicy from './Pages/Return_Policy';
import CookiesPolicy from './Pages/Cookies_Policy';
import TermsAndConditions from './Pages/Terms_And_Condition';
import MYProducts from './Pages/Products';

function ScrollToTopOnPageChange() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div>
      <Router>
        <Header />
        <ScrollToTopOnPageChange /> 
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/About_Us" element={<About />} />
          <Route exact path="/SNKB_History" element={<SNKB_History />} />
          <Route exact path="/Contact_Us" element={<Contact />} />
          <Route exact path="/Our_Category" element={<Our_Category />} />
          <Route exact path="/Products" element={<MYProducts />} />
          <Route path="/Product_Details" element={<Product_Details />} />
          <Route path="/Privacy_Policy" element={<PrivacyPolicy />} />
          <Route path="/Return_Policy" element={<ReturnPolicy />} />
          <Route path="/Cookies_Policy" element={<CookiesPolicy />} />
          <Route path="/Terms_And_Condition" element={<TermsAndConditions />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
